import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

export const StyledInputSelector = styled('select', { shouldForwardProp })(
  ({ disabled, invalid, focus, isRtl, value }) => {
    let type = 'default';
    const isDefaultValue = value === '-1';
    if (disabled) {
      type = 'disabled';
    } else if (invalid) {
      type = 'negative';
    } else if (focus) {
      type = 'branded';
    }

    return css({
      pt: isDefaultValue ? 4 : 5,
      pb: isDefaultValue ? 4 : 2,
      pl: isRtl ? 7 : 3,
      pr: !isRtl ? 7 : 3,
      boxSizing: 'border-box',
      borderRadius: 1,
      borderStyle: 'none',
      fontFamily: 'body',
      fontSize: 'input.text',
      lineHeight: 'input',
      fontWeight: 'normal',
      color: `input.${type}.text`,
      width: '100%',
      backgroundColor: `input.${type}.bg`,
      outline: '0',
      appearance: 'none',
    });
  }
);
